export const setAll = (state, all) => {
  state.all = all;
};

export const setOne = (state, one) => {
  state.one = one;
};
